import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { AbstractService } from '../../../../../core/common/service/AbstractService';

/**
 * User indexのServiceクラス
 * @author GAUSS
 * @since 1.0.0
 *
 * 履歴：
 * NO 日付        更新者        内容
 *  1 2018/06/21 T.Utsunomiya   新規作成
 */
@Injectable()
export class UserIndexService extends AbstractService {
  TENANTS_API_URL = '/admin/tenant';
  constructor(private  httpClient:  HttpClient) {
    super();
  }
  public get() {
    return this.httpClient.get(this.API_URL + "/stream");
  }

  public getTenant(tenantCd : string) {
    return this.httpClient.get(`${this.API_URL}${this.TENANTS_API_URL}/${tenantCd}`);
  }

  public getUsers(tenantCd : string) {
    return this.httpClient.get(`${this.API_URL}/admin/user/${tenantCd}`);
  }

  public delete(id) {
    return this.httpClient.delete(`${this.API_URL}/admin/user/${id}`);
  }

}